import * as React from 'react';


import Box from '@mui/material/Box'


import AddIcon from '@mui/icons-material/Add'
import Alert from '@mui/material/Alert'
import AttachFileIcon from '@mui/icons-material/AttachFile';
import Button from '@mui/material/Button'
import Card from'@mui/material/Card'
import CardContent from'@mui/material/CardContent'
import CardHeader from'@mui/material/CardHeader'
import { CharismaTrainingApi } from '../api/trainings/CharismaTrainingApi.tsx';
import { CharismaStudentTrainingApi } from '../api/studentTrainings/CharismaStudentTrainingApi.tsx';
import CharismaCertificationForm from './certificationForm.tsx';
import CharismaFileForm from '../components/fileForm.tsx'
import CharismaStudentTrainingAssessmentForm from './studentTrainingAssessmentPartForm.tsx';
import { CharismaUserContext } from '../context.tsx';
import Checkbox from '@mui/material/Checkbox';
import DeleteIcon from '@mui/icons-material/Delete'
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import EditIcon from '@mui/icons-material/Edit'
import {extractMonth, formatDate} from '../utils.tsx'
import Grid from '@mui/material/Grid'
import IconButton from '@mui/material/IconButton';
import { Link } from 'react-router-dom';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';




export default function CharismaStudentTrainingCertificatonsList(props){
    


    const [certificationItems, setCertificationItems] = React.useState([]);
    const [certifications, setCertifications] = React.useState([]);
    const [create, setCreate] = React.useState(false);    
    const [deleteCertifications, setDeleteCertifications] = React.useState(false);
    const [selectedCertifications, setSelectedCertifications] = React.useState([]);   
    const [currentCertification, setCurrentCertification] = React.useState(null);    
   
    const lCurrentUser = React.useContext(CharismaUserContext);
    const lReadWrite = lCurrentUser !== null && lCurrentUser !== undefined && lCurrentUser.profile === 0;
    const lStudentTrainingId = props.studentTrainingId;
    const lTrainingId = props.trainingId;
    const lStudentId = props.studentId;


    React.useEffect(()=>{
        const lResponseCertificationItems = CharismaTrainingApi.ListCertificationItems(lTrainingId)
        lResponseCertificationItems.then((value)=>{
            if(value.error === 0){
                setCertificationItems(value.certificationItems);
            }
        }).catch((error)=>{
            
        })
        const lResponseCertifications = CharismaStudentTrainingApi.ListStudentCertifications(lStudentTrainingId)
        lResponseCertifications.then((value)=>{
            if(value.error === 0){
                setCertifications(value.certifications);
            }
        }).catch((error)=>{
            
        })
    }, [lTrainingId, lStudentTrainingId])
    
    
          
    function handleCreateCertification(pDate : string, pItemId : number, pValidation: number, pRetake : number){
        const lResponseCertifications = CharismaStudentTrainingApi.CreateStudentCertification(pItemId, pDate, pValidation, pRetake, lStudentTrainingId)
        lResponseCertifications.then((value)=>{
            if(value.error === 0){
                setCertifications(value.certifications);
            }
        }).catch((error)=>{
            
        })
    } 
    function handleCancelCreate(){
        setCreate(false);
    }

    function handleDeleteCertifications(){         
    }            
    
    function handleSelectedCertification(pEvent : React.ChangeEvent<HTMLInputElement>, pId : number){
        let lNewSelected : number[] = [];
        let lIndex = selectedCertifications.indexOf(pId);
        if(pEvent.target.checked && lIndex === -1){
            lNewSelected = lNewSelected.concat(selectedCertifications, pId);
        }
        else if(lIndex !== -1){
            if(lIndex === 0){
                lNewSelected = lNewSelected.concat(selectedCertifications.slice(1));
            }
            else if(lIndex === selectedCertifications.length - 1){
                lNewSelected = lNewSelected.concat(selectedCertifications.slice(0, -1));
            }
            else{
                lNewSelected = lNewSelected.concat(selectedCertifications.slice(0, lIndex), selectedCertifications.slice(lIndex + 1),);
            }
        }
        setSelectedCertifications(lNewSelected);
    }
    
                
    function handleCancelUpdate(){
        setCurrentCertification(null);
    }
    
    function handleUpdateCertification(pId: number, pDate : string, pItemId: number, pValidation: number, pRetake :number){
        const lResponseCertifications = CharismaStudentTrainingApi.UpdateStudentCertification(pId, pItemId, pDate, pValidation, pRetake, lStudentTrainingId)
        lResponseCertifications.then((value)=>{
            if(value.error === 0){
                setCertifications(value.certifications);
                setCurrentCertification(null)
            }
        }).catch((error)=>{
            
        })
    }
    

    
    function handleEdit(pId : number){
        const lResponseCertifications = CharismaStudentTrainingApi.GetStudentCertification(pId)
        lResponseCertifications.then((value)=>{
            if(value.error === 0){
                setCurrentCertification(value.certification);
            }
        }).catch((error)=>{
            
        })
    }
    
    return(
        
        <Box>
            <Grid container spacing={2}>
                <Grid item xs={12} sm={12}>
                    <Card>
                        <CardHeader
                            title={'Certification'}
                            action={
                                <div>
                                {lReadWrite?
                                <div>
                                <IconButton onClick={()=>setCreate(true)}>
                                    <AddIcon/>
                                </IconButton>
                                {selectedCertifications.length > 0?
                                    <IconButton onClick={()=>setDeleteCertifications(true)}>
                                        <DeleteIcon/>
                                    </IconButton>  
                                    :
                                    null
                                } 
                                </div>
                                :
                                null
                                }                                
                                </div>
                            }
                        />
                        <CardContent>
                            <TableContainer overflowX='auto'>
                            <Table>                               
                                <TableHead>
                                    <TableRow>
                                        {lReadWrite ?
                                            <TableCell padding="checkbox">
                                                </TableCell>
                                              :
                                              null
                                        }
     
                                        <TableCell sx={{minWidth:100}}align='center'>Item</TableCell>
                                        <TableCell sx={{minWidth:100}}align='center'>Date</TableCell>    
                                        <TableCell sx={{minWidth:100}}align='center'>Validation</TableCell>
                                        <TableCell align='center'>Rattrapage</TableCell>
                                        {lReadWrite ?
                                            <TableCell padding="checkbox">
                                                </TableCell>
                                              :
                                              null
                                        }
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {                                     
                                        certifications.map((certification)=>(
                                            <TableRow key={certification.id}>
                                            {lReadWrite ?
                                                <TableCell padding="checkbox">
                                                    <Checkbox
                                                        checked={selectedCertifications.indexOf(certification.id) >= 0}
                                                        onClick={                                    
                                                            (event)=>handleSelectedCertification(event, certification.id)
                                                        }
                                                    />
                                                </TableCell>
                                                :
                                                null
                                            }
                                                <TableCell align='center'>{certification.title}</TableCell>
                                                <TableCell align='center'>                      
                                                    {formatDate(certification.date)}
                                                </TableCell>
                                                <TableCell align='center'>{certification.validation > 0 ? 'Acquis' : 'Non-Acquis'}</TableCell>
                                                <TableCell align='center'>
                                                    <Checkbox
                                                        checked={certification.retake > 0}
                                                        disabled={true}
                                                    />
                                                </TableCell>
                                           {lReadWrite ?
                                                <TableCell padding="checkbox">
                                                    <IconButton
                                                        onClick={()=>handleEdit(certification.id)}
                                                    >
                                                        <EditIcon/>
                                                    </IconButton>
                                                </TableCell>
                                                :
                                                null
                                            }                                                
                                            </TableRow>
                                        ))
                                    }
                    
                                </TableBody>
                            </Table>  
                            </TableContainer>                          
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
            {create ?
                <CharismaCertificationForm
                    items={certificationItems}
                    handleCancel = {handleCancelCreate}
                    handleSubmit = {handleCreateCertification}
                />
                :
                null    
            }    
            {
                currentCertification !== null ?
                    <CharismaCertificationForm
                        items={certificationItems}
                        retake = {currentCertification.retake}
                        date = {currentCertification.date}
                        validation = {currentCertification.validation}
                        item = {currentCertification.item}
                        id = {currentCertification.id}
                        handleCancel = {handleCancelUpdate}
                        handleSubmit = {handleUpdateCertification}
                    />    
                    :
                    null
            }

            
            <Dialog
                open={deleteCertifications}
            >
                <DialogTitle>Suppression de bilans</DialogTitle>
                <DialogContent>
                    <Typography>Etes-vous sûr de vouloir supprimer définitivement les bilans sélectionnés?</Typography>
                    {
                        false?
                            <Alert severity='info'>Suppression en cours...</Alert>
                        :
                        null
                    }
                </DialogContent>
                <DialogActions>
                    <Button autoFocus onClick={()=>setDeleteCertifications(false)}>
                        Annuler
                    </Button>
                    <Button onClick={handleDeleteCertifications}>
                        Valider
                    </Button>
                </DialogActions>
            </Dialog>                     
        </Box>      
    );
    
    
}